/** A normalized, safe-to-display representation of a quote sent to the request workflow. */
export interface ClientQuoteRequestPreview {
  companyName: string | null;
  shipmentDetails: string | null;
  message: string;
}

/**
 * Normalizes client-quote fields for the admin preview and the inbound
 * request's raw message. It is intentionally client-safe and has no DTO or
 * backend dependencies.
 */
export function buildClientQuoteRequestPreview(
  data: Record<string, unknown>,
  email: string
): ClientQuoteRequestPreview {
  const companyName = normalizeSingleLine(data['companyName']) || null;
  const shipmentDetails = normalizeMultiline(data['shipmentDetails']) || null;
  const phone = normalizeSingleLine(data['phone']);

  return {
    companyName,
    shipmentDetails,
    message: [
      'Client quote form submission',
      '',
      `Company: ${companyName || 'Not provided'}`,
      `Email: ${email}`,
      ...(phone ? [`Phone: ${phone}`] : []),
      '',
      'Shipment details:',
      shipmentDetails || 'Not provided',
    ].join('\n'),
  };
}

function normalizeSingleLine(value: unknown): string {
  return typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : '';
}

function normalizeMultiline(value: unknown): string {
  if (typeof value !== 'string') return '';
  return value
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map((line) => line.replace(/\s+/g, ' ').trim())
    .filter(Boolean)
    .join('\n');
}
